import { WORDLIST } from '../constants';
import { applyCase } from '../functions';

export type TextCase = 'sentence' | 'title' | 'upper' | 'lower';

export interface WordOptions {
    lower: number;
    upper: number;
    case: TextCase;
}

export const DEFAULT_WORD_OPTS: WordOptions = {
    lower: 0,
    upper: WORDLIST.length,
    case: 'sentence',
};

export class SpecimenService {
    constructor() {}

    public getRandomWord(options?: WordOptions): string {
        // console.log('getRandomeWord', options);
        const _opts = Object.assign({}, options, DEFAULT_WORD_OPTS);

        // get the possible range to use for the randomizer
        const range = _opts.upper - _opts.lower;
        const randomOffset = Math.floor(Math.random() * range);

        // the point in our array where we're going to start looking for a word.
        const anchor = _opts.lower + randomOffset;

        return applyCase(_opts.case, WORDLIST[anchor]);
    }

    public getSingleLineSpecimen(
        fullwidth: number,
        textCase: TextCase = 'sentence'
    ): string {
        // opts will be mutated internally as we iterate over possible words.
        const _opts = Object.assign({}, { case: textCase }, DEFAULT_WORD_OPTS);

        const tries = 150, // how many times we're willing to try this
            // the index where midword starts
            midwordFlexPoint = Math.floor(WORDLIST.length / 2);

        // get character lengths of the longest and mid length words in the WORDLIST
        const bigword = WORDLIST[WORDLIST.length - 1].length;
        const midword = WORDLIST[midwordFlexPoint].length;

        let attempt = 0;
        let length = 0;

        const words: string[] = [];

        // try to full with words to within 20px  of the available width, make up to 150 attempts.
        // it's important that we try to fill all of the space here, so we keep trying to
        // fit smaller and smaller words to make it happen.
        while (
            attempt++ < tries &&
            length < fullwidth - 20 &&
            _opts.upper > 0
        ) {
            // size > 110 && console.log('getSingleLineSpeciment', style.label, size, textCase, { fullwidth, length, fits: length < fullwidth }, _opts.upper, words);

            // step down our initital starting point if necessary.
            if (fullwidth - length < bigword) {
                _opts.upper = midwordFlexPoint;
            }

            if (fullwidth - length < midword) {
                _opts.upper = midwordFlexPoint / 2;
            }

            if (_opts.upper <= _opts.lower) {
                _opts.upper = Math.floor(_opts.upper / 2);
                _opts.lower = 0;
            }

            const newWord = this.getRandomWord(_opts);
            // do not repeat words.
            if (newWord == words[words.length - 1]) continue;

            words.push(newWord);
            const candidateString = applyCase(textCase, words.join(' '));
            const candidateLength = candidateString.length;

            if (candidateLength < fullwidth) {
                length = candidateLength;
            } else {
                // we went over our total allowed length back out the last change and keep trying to fill.
                words.pop();
            }
        }
        return words.join(' ');
    }
}
